"use strict";
/**
 * Make unicode gemojis accessible
 * by wrapping them in aria labeled <span>'s
 * code mostly reused from https://gitlab.com/staltz/remark-linkify-regex
 *
 * DONE: improve so it won't wrap emojis in <scripts> etc
 * https://github.com/rehypejs/rehype/pull/30#issuecomment-570914503
 * https://github.com/syntax-tree/hast-util-find-and-replace/blob/master/index.js#L9
 */

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var unist_util_flatmap_1 = __importDefault(require("unist-util-flatmap"));

var hast_util_is_element_1 = __importDefault(require("hast-util-is-element"));

var emoji_regex_1 = __importDefault(require("emoji-regex"));

var gemoji = require('gemoji');

var defaultIgnore = ['title', 'script', 'style', 'svg', 'math'];

function removeExtremes(regex, optionalFlags) {
  return new RegExp(regex.source.replace(/^\^/, '').replace(/\$$/, ''), optionalFlags || regex.flags);
}

function buildTextNode(value) {
  return {
    type: 'text',
    value: value
  };
}

function buildEmojiNode(emoji, children) {
  var description = gemoji.unicode[emoji] ? gemoji.unicode[emoji].description : '';
  return {
    type: "element",
    tagName: "span",
    properties: _objectSpread({
      role: "img",
      ariaLabel: description
    }, !!!description ? {
      ariaHidden: true
    } : {}),
    children: children
  };
}

function h(type, props, children) {
  if (type === 'text') return buildTextNode(props.value);
  if (type === 'emoji') return buildEmojiNode(props.value, children);
  throw new Error('mdast hyperscript not supported for type ' + type);
}

function splitTextNode(textNode) {
  var oldText = textNode.value;
  var regex = removeExtremes(emoji_regex_1.default());
  var newNodes = [];
  var startTextIdx = 0;
  var output;

  while ((output = regex.exec(oldText)) !== null) {
    var endTextIdx = output.index;

    if (startTextIdx !== endTextIdx) {
      newNodes.push(h('text', {
        value: oldText.slice(startTextIdx, endTextIdx)
      }));
    }

    var emoji = output[0];
    newNodes.push(h('emoji', {
      value: emoji
    }, [h('text', {
      value: emoji
    })]));
    startTextIdx = regex.lastIndex;
  }

  var remainingText = oldText.slice(startTextIdx);

  if (remainingText.length > 0) {
    newNodes.push(h('text', {
      value: remainingText
    }));
  }

  return newNodes;
}

var defaultOptions = {
  ignore: []
}; // from https://medium.com/dailyjs/how-to-remove-array-duplicates-in-es6-5daa8789641c

var unique = function unique(array) {
  return array.filter(function (item, index) {
    return array.indexOf(item) === index;
  });
};

exports.rehypeAccessibleEmojis = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  return function (ast) {
    var ignore = unique([].concat(defaultIgnore, _toConsumableArray(options.ignore)));
    unist_util_flatmap_1.default(ast, function (node, _, parent) {
      if (node.type !== 'text' || parent && hast_util_is_element_1.default(parent, ignore)) {
        return [node];
      }

      return splitTextNode(node);
    });
    return ast;
  };
};